export enum OpeningType {
  Frontal = 'frontal',
  Dorsal = 'dorsal',
}
